export const CERTIFICATE_DIALOG_ID = "certificate-dialog";

export function certificateDialogPresent(): boolean {
  return document.getElementById(CERTIFICATE_DIALOG_ID) !== null;
}
